import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

import NavigationBar from 'components/inc/NavigationBar.jsx';

import ProjectForm from '../../components/StepWizard/Project/ProjectForm';
import { Container, Grid } from '@material-ui/core';

class CreateProjectPage extends React.Component {
  render() {
    return (
      <main>
        <NavigationBar />
        <Container maxWidth='lg' component='section'>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <h3>Create new project</h3>
            </Grid>
          </Grid>
          <ProjectForm />
        </Container>
      </main>
    );
  }
}

export default withStyles()(CreateProjectPage);
